<script setup lang="ts">
  import { type RecentSearch } from '../../utils/search-types'
  import { useSearch, useRecentSearch } from '../../utils/search-providers'
  import {
    type SearchContextType,
    searchContextTypesMapping,
    type SearchContextMetadata
  } from '../../utils/global-search-utils'
  import { globalUtils } from '@gat-ship/utils'
  import { computed } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  const props = defineProps<RecentSearch & { class?: string }>()

  const { callSearch, searchInputRef, selectedSearchContext } = useSearch()
  const { recentSearchItems, clearRecentSearches } = useRecentSearch()

  function onRecentSearchItemClicked(search: RecentSearch) {
    callSearch(search.searchString, search.context)
    searchInputRef.value?.focus()
  }

  function getMetadata(context: SearchContextType): SearchContextMetadata {
    return searchContextTypesMapping[context]
  }

  // function onKeyDownDown(event: KeyboardEvent) {
  //   console.log('focus next recent search item')
  //   event.preventDefault()
  //   const nextEl = (event.currentTarget as HTMLElement).nextElementSibling
  //   if (nextEl && nextEl instanceof HTMLElement) {
  //     ;(nextEl as HTMLElement).focus()
  //     return
  //   }
  //   const isLastItem = event.currentTarget === event.target
  //   if (isLastItem) {
  //     searchInputRef.value?.focus()
  //   }
  // }
  // function onKeyDownUp(event: KeyboardEvent) {
  //   console.log('focus previous recent search item')
  //   event.preventDefault()
  //   const prevEl = (event.currentTarget as HTMLElement).previousElementSibling
  //   if (prevEl && prevEl instanceof HTMLElement) {
  //     ;(prevEl as HTMLElement).focus()
  //   }
  //   const isFirstItem = event.currentTarget === event.target
  //   if (isFirstItem) {
  //     searchInputRef.value?.focus()
  //   }
  // }
</script>

<template>
  <div :class="cn('flex items-center gap-2 px-4 py-2', props.class)">
    <gat-icon :icon="'History'" class="size-4" />
    <div class="text-sm">
      <span class="text-soft">Searched for: </span>
      <span class="font-medium">"{{ props.searchString }}"</span>
      <span class="text-soft"> in {{ getMetadata(props.context).title }}</span>
    </div>
    <slot name="actions">
      <div class="text-soft ml-auto text-xs">
        {{
          globalUtils.date.timeSince(
            globalUtils.date.convertTimestampToISODateTimeString(
              props.timestamp
            )
          )
        }}
      </div>
    </slot>
  </div>
</template>
